var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17281",
    "data-name": "Groupe 17281",
    transform: "translate(-1113 2549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5353",
    "data-name": "Rectangle 5353",
    width: 40,
    height: 40,
    rx: 7,
    transform: "translate(1113 -2549)",
    fill: "#f45843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12029",
    "data-name": "Trac\\xE9 12029",
    d: "M13.132,3.14c-4.1,0-7.985-.364-9.47,3.445-.614,1.573-.524,3.617-.524,6.542,0,2.567-.082,4.98.524,6.541,1.482,3.812,5.4,3.446,9.468,3.446,3.922,0,7.965.408,9.469-3.446.615-1.589.524-3.6.524-6.541,0-3.9.215-6.421-1.678-8.312C19.527,2.9,16.934,3.14,13.128,3.14Zm-.9,1.8c8.543-.014,9.63-.962,9.03,12.22-.213,4.663-3.766,4.151-8.134,4.151-7.963,0-8.192-.228-8.192-8.188,0-8.053.632-8.179,7.3-8.186ZM18.467,6.6a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,18.467,6.6ZM13.132,8a5.129,5.129,0,1,0,5.131,5.129A5.131,5.131,0,0,0,13.132,8Zm0,1.8c4.4,0,4.41,6.659,0,6.659S8.722,9.8,13.132,9.8Z",
    transform: "translate(1119.867 -2542.131)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.b5a602fd8b8be0c5143a911eb7039f7e.svg";
export { ForwardRef as ReactComponent };